module.exports = __webpack_public_path__ + "img/ActForex.d236b6ef.png";